import { Injectable } from "@angular/core";
import { NetworkService } from "../common/network.service";
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class AuthService {
  constructor(private networkService: NetworkService) { }

  validateLogin(req: any) {
    return this.networkService.login("api/admins/login", req, null, null);
  }
  forgotPassword(req: any) {
    return this.networkService.post("api/auth/admin/forgotPassword", req, null, null);
  }
  resetPassword(req: any) {
    return this.networkService.post("api/auth/password/reset/", req, null, null);
  }
  createOpt(req: any) {
    return this.networkService.login("api/otp/create/admin", req, null, null);
  }

  verifyOtp(req: any) {
    return this.networkService.login("api/otp/verify", req, null, null);
  }
  unsubsribeEmail(req: any) {
    return this.networkService.put("api/users/email/unsubscribe", req, null, null);
  }

}

